import React from "react";
import FitnessTraining from "../elements/FitnessTraining";
import PageTitle from "../elements/PageTitle";
import { useLanguage } from "../i18n/LanguageContext";

const Libraries = () => {
  const { t } = useLanguage();
  return (
  <div className="page-content bg-white hpa-libraries-page">
    <PageTitle activePage="Libraries" parentTitle="Home" />
    <section className="content-inner hpa-libraries-catalog">
      <div className="container">
        <div className="section-head style-1 text-center hpa-library-page-heading">
          <span className="sub-title">{t("Train with a clear structure")}</span>
          <h2 className="title">
            {t("Explore Our Libraries")}
          </h2>
          <p className="p-big mx-auto">
            {t("Choose the training system that fits your goals. Your active package determines which libraries you can open.")}
          </p>
        </div>
        <FitnessTraining />
      </div>
    </section>
  </div>
  );
};

export default Libraries;
